// extracted by mini-css-extract-plugin
export var label = "_5f-1";
export var reminder = "_5f-0";